<script setup lang="ts">
import { SpeedInsights } from '@vercel/speed-insights/vue'
import { toast } from 'vue-sonner'

defineProps({
  theme: {
    type: String,
    default: 'dark',
  },
  showNavbar: {
    type: Boolean,
    default: true,
  },
})
const config = useRuntimeConfig()
const $router = useRouter()
const localePath = useLocalePath()
const { checkRedirectResult, authError } = useLogin()

function loginSuccessRedirect() {
  const hasPrevRoute = localStorage.getItem('prevRoute')
  if (hasPrevRoute) {
    $router.replace(localePath(hasPrevRoute))
    localStorage.removeItem('prevRoute')
  }
  toast.success('登入成功')
}

watch(authError, (err) => {
  if (err)
    toast.error(`登入失敗: ${err.message}`)
})

onMounted(async () => {
  if (config.public.signInWithPopup)
    return

  const result = await checkRedirectResult()
  if (!result)
    return

  loginSuccessRedirect()
})
</script>

<template>
  <common-navbar v-if="showNavbar" :theme="theme" />
  <main class="flex-1 bg-silver">
    <slot />
  </main>
  <SpeedInsights />
</template>
